(function () {
  if (window.__prRitualAtcBound) return;
  window.__prRitualAtcBound = true;

  var root =
    window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

  /* ---- Compare (ritual cards only) ---- */
  var COMPARE_KEY = 'hm_product_compare';
  var COMPARE_MAX_DESKTOP = 4;
  var COMPARE_MAX_MOBILE = 2;

  function getCompareMax() {
    return window.matchMedia('(max-width: 767px)').matches
      ? COMPARE_MAX_MOBILE
      : COMPARE_MAX_DESKTOP;
  }

  function readCompareList() {
    try {
      var raw = sessionStorage.getItem(COMPARE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(list)) return [];
      var max = getCompareMax();
      return list.length > max ? list.slice(list.length - max) : list;
    } catch (e) {
      return [];
    }
  }

  function writeCompareList(list) {
    try {
      sessionStorage.setItem(COMPARE_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function productFromButton(btn) {
    return {
      id: String(btn.getAttribute('data-product-id') || ''),
      handle: btn.getAttribute('data-product-handle') || '',
      title: btn.getAttribute('data-product-title') || '',
      url: btn.getAttribute('data-product-url') || '',
      price: btn.getAttribute('data-product-price') || '',
      comparePrice: btn.getAttribute('data-product-compare-price') || '',
      image: btn.getAttribute('data-product-image') || '',
      size: btn.getAttribute('data-product-size') || '',
      tags: (btn.getAttribute('data-product-tags') || '')
        .split('|')
        .map(function (t) {
          return t.trim();
        })
        .filter(Boolean),
    };
  }

  function syncCompareButtons() {
    var ids = readCompareList().map(function (p) {
      return String(p.id);
    });
    document.querySelectorAll('[data-hm-compare]').forEach(function (btn) {
      var id = String(btn.getAttribute('data-product-id') || '');
      var active = ids.indexOf(id) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('title', active ? 'Added to Compare' : 'Compare');
      var label = btn.querySelector('.hm-coll-card__compare-label');
      if (label) label.textContent = active ? 'Added' : 'Compare';
    });
  }

  function ensureComparePopup() {
    var existing = document.getElementById('hm-compare-overlay');
    if (existing && !existing.querySelector('[data-hm-compare-scaler]')) {
      existing.remove();
      existing = null;
    }
    if (existing) return existing;

    var overlay = document.createElement('div');
    overlay.id = 'hm-compare-overlay';
    overlay.className = 'hm-compare-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Compare products');
    overlay.innerHTML =
      '<div class="hm-compare-stage">' +
      '<div class="hm-compare-fit" data-hm-compare-fit>' +
      '<div class="hm-compare-scaler" data-hm-compare-scaler>' +
      '<div class="hm-compare-panel" data-hm-compare-panel>' +
      '<div class="hm-compare-panel__header">' +
      '<p class="hm-compare-panel__title">Compare Products</p>' +
      '<button type="button" class="hm-compare-panel__close" data-hm-compare-close aria-label="Close">×</button>' +
      '</div>' +
      '<p class="hm-compare-panel__hint" data-hm-compare-hint></p>' +
      '<div class="hm-compare-grid" data-hm-compare-grid></div>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '</div>';
    document.body.appendChild(overlay);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeComparePopup();
    });
    overlay.querySelector('[data-hm-compare-close]').addEventListener('click', closeComparePopup);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeComparePopup();
    });
    window.addEventListener('resize', fitComparePanel);
    return overlay;
  }

  function fitComparePanel() {
    var overlay = document.getElementById('hm-compare-overlay');
    if (!overlay || !overlay.classList.contains('is-open')) return;

    var fit = overlay.querySelector('[data-hm-compare-fit]');
    var scaler = overlay.querySelector('[data-hm-compare-scaler]');
    var panel = overlay.querySelector('[data-hm-compare-panel]');
    if (!fit || !scaler || !panel) return;

    scaler.style.transform = 'scale(1)';
    fit.style.width = 'auto';
    fit.style.height = 'auto';

    requestAnimationFrame(function () {
      var pad = window.innerWidth < 768 ? 20 : 40;
      var availW = Math.max(260, window.innerWidth - pad);
      var availH = Math.max(280, window.innerHeight - pad);
      var naturalW = panel.offsetWidth;
      var naturalH = panel.offsetHeight;
      if (!naturalW || !naturalH) return;

      var scale = Math.min(1, availW / naturalW, availH / naturalH);
      scaler.style.transform = 'scale(' + scale + ')';
      fit.style.width = Math.round(naturalW * scale) + 'px';
      fit.style.height = Math.round(naturalH * scale) + 'px';
    });
  }

  function openComparePopup(list) {
    if (!list || list.length < 2) return;

    var overlay = ensureComparePopup();
    var panel = overlay.querySelector('[data-hm-compare-panel]');
    var grid = overlay.querySelector('[data-hm-compare-grid]');
    var hint = overlay.querySelector('[data-hm-compare-hint]');

    var max = getCompareMax();
    if (list.length > max) list = list.slice(list.length - max);
    hint.textContent = 'Comparing ' + list.length + ' of ' + max + ' blends side by side.';
    grid.setAttribute('data-count', String(list.length));
    grid.innerHTML = list
      .map(function (p) {
        var tags = (p.tags || [])
          .slice(0, window.matchMedia('(max-width: 1024px)').matches ? 2 : 3)
          .map(function (t) {
            return '<span class="hm-compare-card__tag">' + escapeHtml(t) + '</span>';
          })
          .join('');
        if (!tags) {
          tags = '<span class="hm-compare-card__tag hm-compare-card__tag--spacer" aria-hidden="true">&nbsp;</span>';
        }
        var priceHtml = p.comparePrice
          ? '<span class="hm-compare-card__price-compare">' +
            escapeHtml(p.comparePrice) +
            '</span><span class="hm-compare-card__price-sale">' +
            escapeHtml(p.price) +
            '</span>'
          : '<span class="hm-compare-card__price-regular">' + escapeHtml(p.price) + '</span>';
        var img = p.image
          ? '<img src="' + escapeAttr(p.image) + '" alt="' + escapeAttr(p.title) + '" loading="lazy" width="400" height="400">'
          : '';
        return (
          '<article class="hm-compare-card" data-compare-id="' +
          escapeAttr(p.id) +
          '">' +
          '<div class="hm-compare-card__media">' +
          img +
          '<button type="button" class="hm-compare-card__remove" data-hm-compare-remove="' +
          escapeAttr(p.id) +
          '" aria-label="Remove from compare">×</button>' +
          '</div>' +
          '<div class="hm-compare-card__body">' +
          '<h3 class="hm-compare-card__title"><a href="' +
          escapeAttr(p.url) +
          '">' +
          escapeHtml(p.title) +
          '</a></h3>' +
          '<p class="hm-compare-card__meta">' +
          (p.size ? escapeHtml(p.size) : '&nbsp;') +
          '</p>' +
          '<div class="hm-compare-card__tags">' +
          tags +
          '</div>' +
          '<div class="hm-compare-card__price">' +
          priceHtml +
          '</div>' +
          '<a class="hm-compare-card__view" href="' +
          escapeAttr(p.url) +
          '">View Product</a>' +
          '</div>' +
          '</article>'
        );
      })
      .join('');

    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    fitComparePanel();
    requestAnimationFrame(function () {
      panel.classList.add('is-flipped');
      fitComparePanel();
      setTimeout(fitComparePanel, 60);
      setTimeout(fitComparePanel, 360);
    });

    grid.querySelectorAll('img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', fitComparePanel, { once: true });
    });
  }

  function refreshOpenComparePopup() {
    var overlay = document.getElementById('hm-compare-overlay');
    if (!overlay || !overlay.classList.contains('is-open')) return;
    var list = readCompareList();
    if (list.length < 2) {
      closeComparePopup();
      return;
    }
    openComparePopup(list);
  }

  function closeComparePopup() {
    var overlay = document.getElementById('hm-compare-overlay');
    if (!overlay) return;
    var panel = overlay.querySelector('[data-hm-compare-panel]');
    if (panel) panel.classList.remove('is-flipped');
    setTimeout(function () {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }, 280);
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(str) {
    return escapeHtml(str).replace(/'/g, '&#39;');
  }

  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-hm-compare-remove]');
    if (removeBtn) {
      var removeId = String(removeBtn.getAttribute('data-hm-compare-remove') || '');
      var next = readCompareList().filter(function (p) {
        return String(p.id) !== removeId;
      });
      writeCompareList(next);
      syncCompareButtons();
      refreshOpenComparePopup();
      return;
    }

    var btn = e.target.closest('[data-hm-compare]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var product = productFromButton(btn);
    if (!product.id) return;

    var list = readCompareList();
    var exists = list.some(function (p) {
      return String(p.id) === product.id;
    });

    if (exists) {
      list = list.filter(function (p) {
        return String(p.id) !== product.id;
      });
    } else {
      var max = getCompareMax();
      while (list.length >= max) {
        list.shift();
      }
      list.push(product);
    }

    writeCompareList(list);
    syncCompareButtons();
    if (list.length >= 2) {
      openComparePopup(list);
    } else {
      closeComparePopup();
    }
  });

  syncCompareButtons();

  function refreshCartUI() {
    function applyCart(cart) {
      if (!cart) return;

      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        if (cart.item_count >= 100 && window.cartStrings && window.cartStrings.item_99) {
          el.textContent = window.cartStrings.item_99;
        } else {
          el.textContent = cart.item_count;
        }
      });

      document.querySelectorAll('[data-cart-text]').forEach(function (el) {
        if (!window.cartStrings) return;
        el.textContent = cart.item_count === 1 ? window.cartStrings.item : window.cartStrings.items;
      });

      if (typeof window.halo !== 'undefined' && typeof window.halo.updateSidebarCart === 'function') {
        window.halo.updateSidebarCart(cart);
      } else if (window.sharedFunctions && typeof window.sharedFunctions.updateSidebarCart === 'function') {
        window.sharedFunctions.updateSidebarCart(cart);
      }

      document.dispatchEvent(new CustomEvent('cart-update', { detail: cart, bubbles: true }));

      var afterType = window.after_add_to_cart && window.after_add_to_cart.type;
      if (afterType === 'cart') {
        window.location.href = window.routes && window.routes.cart ? window.routes.cart : '/cart';
        return;
      }
      if (!afterType || afterType === 'quick_cart' || afterType === 'popup_cart_1') {
        document.body.classList.add('cart-sidebar-show');
      }
    }

    if (typeof Shopify !== 'undefined' && typeof Shopify.getCart === 'function') {
      Shopify.getCart(applyCart);
    } else {
      fetch(root + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) {
          return r.json();
        })
        .then(applyCart)
        .catch(function (err) {
          console.error('Cart refresh failed:', err);
        });
    }
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target.closest('[data-pr-atc-form]');
      if (!form) return;
      e.preventDefault();

      var button = form.querySelector('.pr-btn, .hm-coll-card__btn');
      var buttonText =
        button &&
        (button.querySelector('[data-pr-btn-label]') || button.querySelector('span'));
      if (!button || !buttonText) return;

      var originalText = buttonText.textContent;
      var variantInput = form.querySelector('[name="id"]');
      var variantId = variantInput ? variantInput.value : null;
      if (!variantId) return;

      button.disabled = true;
      buttonText.textContent = 'Adding...';

      fetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
        }),
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok || result.data.status || result.data.errors || result.data.message === 'Cart Error') {
            var msg =
              (result.data && (result.data.description || result.data.message)) || 'Could not add to cart';
            throw new Error(msg);
          }
          buttonText.textContent = 'Added!';
          refreshCartUI();
          setTimeout(function () {
            buttonText.textContent = originalText;
            button.disabled = false;
          }, 1500);
        })
        .catch(function (error) {
          console.error('Error adding to cart:', error);
          buttonText.textContent = originalText;
          button.disabled = false;
          if (typeof window.halo !== 'undefined' && typeof window.halo.showWarning === 'function') {
            window.halo.showWarning(error.message || 'Could not add to cart');
          }
        });
    },
    true
  );
})();
